import { render, staticRenderFns } from "./MoveWindow.vue?vue&type=template&id=63f05306&scoped=true"
import script from "./MoveWindow.vue?vue&type=script&lang=js"
export * from "./MoveWindow.vue?vue&type=script&lang=js"
import style0 from "./MoveWindow.vue?vue&type=style&index=0&id=63f05306&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f05306",
  null
  
)

export default component.exports